import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow } from "vue"
import _imports_0 from '../assets/images/parts/icon_search_small.png'
import _imports_1 from '../assets/images/parts/button_search_delete.png'
import _imports_2 from '../assets/images/parts/icon_search_large.png'


const _hoisted_1 = { class: "relative text-center px-[16px]" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Search",
  class: "absolute top-[16px] left-[32px] transform w-6 h-6"
}, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "mx-auto relative w-full hover:bg-green-50 cursor-pointer" }
const _hoisted_6 = {
  key: 0,
  class: "p-2"
}
const _hoisted_7 = {
  key: 0,
  class: "gl_ly_main_blank mt-[256px] my-[640px]"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "gl_bl_icon",
  src: _imports_2,
  alt: "history...",
  loading: "lazy",
  width: "120px",
  height: "120px"
}, null, -1)
const _hoisted_9 = { class: "gl_bl_text" }

import { ref, watch } from "vue";
import PredictionItem from "../components/PredictionItem.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'WordSearchBox',
  setup(__props) {

// eslint-disable-next-line no-unused-vars
const inputText = ref("");
const predictions = ref([]);


watch(inputText, (newValue, oldValue) => {
  // Check if the new value contains non-alphabet characters
  if (!/^[a-zA-Z]*$/.test(newValue)) {
    // If it does, revert the value to the old one
    inputText.value = oldValue;
  }
});

const fetchPredictions = () => {
  if (inputText.value.length > 1) {
    fetch(
      `https://api.datamuse.com/sug?s=${encodeURIComponent(inputText.value)}`
    )
      .then((response) => response.json())
      .then((data) => {
        const filteredData = data
          .filter((item) => !item.word.includes(" "))
          .slice(0, 10);
        predictions.value = filteredData;
      })
      .catch((error) => console.error("Error:", error));
  } else {
    predictions.value = []; // 入力が少ない場合はリストをクリア
  }
};

function deleteWord() {
  console.log("deleteWord");
  inputText.value = "";
  predictions.value = [];
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputText).value = $event)),
        onInput: fetchPredictions,
        placeholder: _ctx.$t('lt_common.search_placeholder'),
        autocomplete: "off",
        pattern: "^[a-zA-Z]+$",
        class: "w-full h-[56px] pl-12 border-2 rounded-md focus:ring focus:ring-green-300 focus:border-green-300"
      }, null, 40, _hoisted_2), [
        [_vModelText, inputText.value]
      ]),
      _hoisted_3,
      (inputText.value.length >= 1)
        ? (_openBlock(), _createElementBlock("button", _hoisted_4, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: "Search",
              class: "absolute top-[16px] right-[32px] transform w-6 h-6",
              onClick: deleteWord
            })
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(predictions.value, (prediction) => {
          return (_openBlock(), _createBlock(PredictionItem, {
            word: prediction.word,
            key: prediction.word
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(prediction.word), 1)
            ]),
            _: 2
          }, 1032, ["word"]))
        }), 128)),
        (predictions.value.length === 0 && inputText.value.length < 2)
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, " 2文字以上入力してください "))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, inputText.value]
      ])
    ]),
    (predictions.value.length == 0 && inputText.value.length >= 2)
      ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('main_blank.search')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})